import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import './assets/css/global.css'
import '../mock/index.js'

createApp(App).use(store).use(ElementPlus).mount('#app')
